export default __webpack_public_path__ + "static/media/body_2_male.f5ab469a.png";